import InternalLink from 'components/UI/InternalLink'
import { ArticlesArrowComponent, KBWrapper } from 'components/knowledge-base/Categories'
import { ReactElement } from 'react'
import { HitsProvided } from 'react-instantsearch-core'
import { Flex, Text, get } from 'theme-ui'

interface Hit {
  title: string
  body: string
}

type HitsProps = HitsProvided<Hit>

export default function Hits({ hits }: HitsProps): ReactElement {
  return (
    <KBWrapper>
      <Flex
        sx={{
          flexDirection: 'column',
          width: '100%',
          pl: '2.4rem',
          pt: '2.4rem',
          pb: '1.6rem',
        }}
      >
        <Flex
          sx={{
            gap: '1.6rem',
            '&:hover': {
              path: { opacity: 1 },
              span: { color: 'white' },
              cursor: 'pointer',
            },
            mb: '2.4rem',
            alignItems: 'center',
            width: 'fit-content',
          }}
          onClick={() => document.getElementsByClassName('ais-SearchBox-reset')?.[0]?.click()}
        >
          <ArticlesArrowComponent
            sxx={{ transform: 'rotate(180deg)', path: { strokeOpacity: 1 } }}
          />
          <Text
            variant="h3Big"
            data-testid="Hits_searchResult"
          >{`Search Results (${hits.length})`}</Text>
        </Flex>
        {hits.map((hit, index) => (
          <Flex
            data-testid={hit.page_path}
            key={hit.objectID}
            sx={{
              py: '0.8rem',
              borderBottom: index === hits.length - 1 ? 'unset' : '0.2rem solid',
              borderBottomColor: index === hits.length - 1 ? 'unset' : 'white15',
              transition: theme => `${get(theme, 'transitions.default')}`,
              '.articles-arrow': {
                transition: theme => `${get(theme, 'transitions.default')}`,
              },
              ':hover': {
                span: {
                  color: 'white',
                },
                '.articles-arrow': {
                  path: {
                    strokeOpacity: 1,
                  },
                },
              },
            }}
          >
            <InternalLink href={hit.page_path} sxx={{ width: '100%', pr: '1.6rem' }}>
              <Flex
                sx={{
                  display: 'flex',
                  textDecoration: 'none',
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Flex sx={{ flexDirection: 'column' }}>
                  <Text variant="paragraphSmallRegular">{hit.title}</Text>
                </Flex>
                <ArticlesArrowComponent
                  className="articles-arrow"
                  sx={{
                    marginLeft: ['1.6rem', '2.4rem', '2.4rem'],
                  }}
                />
              </Flex>
            </InternalLink>
          </Flex>
        ))}
      </Flex>
    </KBWrapper>
  )
}
